import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';

import {timeout} from "rxjs/operators";

import {ServerTimeoutDialogComponent} from "@shared/components/server-timeout-dialog/server-timeout-dialog.component";
import {TimeoutDialogComponent} from "@shared/components/timeout-dialog/timeout-dialog.component";
import {DialogService} from "@shared/services/dialog.service";

@Injectable({
  providedIn: 'root'
})
export class ShowTimeoutModalService {

  //api nie wymagające autentykacji
  private readonly apiUrl = 'https://en.wikipedia.org/api/rest_v1/page/';

  private showTimeout = false;

  private dialog: MatDialogRef<any, any>;

  constructor(
    private dialogService: DialogService,
    private httpClient: HttpClient) {
  }

  public showModal(): void {
    if (this.showTimeout)
      return;

    this.showTimeout = true;

    this.httpClient.get(this.apiUrl, {observe: 'response'})
      .pipe(timeout(5000))
      .subscribe({
        next: (x) => {
          const component = x.status === 200 ? ServerTimeoutDialogComponent : TimeoutDialogComponent;
          this.dialogService.open(component);
        },
        error: () => {
          this.dialog = this.dialogService.open(TimeoutDialogComponent);
        }
      });
  }

  public hideModal(): void {
    this.dialog.close();
  }

}
